/** Standard namespaces, plus Costanza's own `attensi:*`. */

export const NS_CLIENT = "jabber:client"

/** XEP-0203 delayed delivery. */
export const NS_DELAY = "urn:xmpp:delay"

/** XEP-0359 `<origin-id/>` and `<stanza-id/>`. */
export const NS_SID = "urn:xmpp:sid:0"

/** RFC 6120 error conditions. */
export const NS_STANZAS = "urn:ietf:params:xml:ns:xmpp-stanzas"

/** XEP-0313 message archive management. */
export const NS_MAM = "urn:xmpp:mam:2"

/** XEP-0059 result set management. */
export const NS_RSM = "http://jabber.org/protocol/rsm"

/** XEP-0297 stanza forwarding — wraps carbons and MAM results. */
export const NS_FORWARD = "urn:xmpp:forward:0"

/** XEP-0280 message carbons. */
export const NS_CARBONS = "urn:xmpp:carbons:2"

/** XEP-0357 push notifications. */
export const NS_PUSH = "urn:xmpp:push:0"

/** The pubsub node the PushGateway routes engagement pushes on (FAME-853). */
export const PUSH_NODE = "engage"

/** XEP-0004 data forms. */
export const NS_DATA_FORM = "jabber:x:data"

/** XEP-0085 chat states — typing indicators. */
export const NS_CHATSTATES = "http://jabber.org/protocol/chatstates"

/** XEP-0060 pubsub event — the MUC/Sub envelope. */
export const NS_PUBSUB_EVENT = "http://jabber.org/protocol/pubsub#event"

/** Group messages, as opposed to subject or config. */
export const MUCSUB_MESSAGES_NODE = "urn:xmpp:mucsub:nodes:messages"

/** XEP-0424 message retraction. */
export const NS_MESSAGE_RETRACT = "urn:xmpp:message-retract:1"

/** XEP-0308 last message correction: an Edit names its target in `<replace/>`. */
export const NS_MESSAGE_CORRECT = "urn:xmpp:message-correct:0"

/** Costanza's Edited marker; its `stamp` is the server's time of the latest Edit. */
export const NS_ATTENSI_EDIT = "attensi:edit:0"

/**
 * Costanza's system notices. Container-agnostic — the same marker is planned
 * for 1:1, so it is not named after the MUC room it currently arrives in.
 *
 * Its element is `<event>`, which is ALSO the pubsub envelope's tag. The
 * namespace is the only thing telling them apart, so never look for this one
 * without it.
 */
export const NS_ATTENSI_EVENT = "attensi:event:0"

/** Costanza's `<author/>` attribution marker (FAME-608). */
export const NS_ATTENSI_CHAT = "attensi:chat:0"

/**
 * The shared-learning-item marker (FAME-237). Carries only a reference — item
 * type + id — which ejabberd and MAM route opaquely; the receiver resolves it
 * to displayable metadata through the authorized endpoint (FAME-453).
 */
export const NS_ATTENSI_SHARE = "attensi:share:0"

/** The image-attachment marker: an uploaded Attachment's id and pixel size. */
export const NS_ATTENSI_ATTACHMENT = "attensi:attachment:0"

export const NS_RETRACTION_ERRORS = "attensi:retraction:errors"

export const NS_GROUP_ERRORS = "attensi:group:errors"

export const NS_EDIT_ERRORS = "attensi:edit:errors"

export const EVENT_TYPES = [
  "archived",
  "unarchived",
  "renamed",
  "member_added",
  "member_removed",
  "member_left",
  "promoted",
  "demoted",
] as const
